export default __webpack_public_path__ + "static/cdc-d4a411b5198c79fcf960facd1c75669e.jpg";